import type { Id } from '@e-socna/data-layer';

import { hasSubMissions } from '../../../app/utils/mission-kind-profile.util';

import type { MissionForm_Mission } from '../fragments/mission.fragment';

// The collaboration a simple mission is turned into does not exist yet: the
// form holds this placeholder as its collaboration until the back creates it.
export const NEW_COLLABORATION_ID = 'new-collaboration' as Id;

export const isTurningIntoCollaboration = (
  mission: Readonly<Pick<MissionForm_Mission, 'compositeMissionId'>>,
): boolean => mission.compositeMissionId === NEW_COLLABORATION_ID;

export const canBeTurnedIntoCollaboration = (
  mission: Readonly<Pick<MissionForm_Mission, 'kind'>>,
): boolean => !hasSubMissions(mission.kind);
